<div class="dqf-review page gray-font-color font-family" data-testid="dqf-review">
  <div class="header-navigation-back">
    <div class="back-icon" (click)="backAction()" data-testid="dqf-review-back">
      <mat-icon svgIcon="left-arrow"></mat-icon>
    </div>
    <div class="header-text" data-testid="dqf-review-header">{{ carrierCompanyName }}</div>
  </div>
  @if (!isContentReady) {
    <div class="loading-container">
      <app-skeleton-dqf-review></app-skeleton-dqf-review>
    </div>
  }
  @if (isContentReady && isVersionsLoaded) {
    <div class="content">
      <div class="sections-list-container">
        <div class="sections-list">
          @for (info of profileInfo; track info) {
            <div class="section-item"
                 [ngClass]="getStatusClass(info)"
                 [class.has-reupload-hint]="!!getReuploadMessage(info)"
                 (click)="onSectionClick(info)"
                 [attr.data-testid]="'dqf-review-' + (info.heading | lowercase)">
              <div class="section-icon-wrapper">
                <mat-icon class="section-icon" [svgIcon]="getSectionIcon(info.value)"></mat-icon>
              </div>
              <div class="section-info">
                <h3 class="section-title" [attr.data-testid]="'dqf-review-name-' + (info.heading | lowercase)">{{ info.heading }}</h3>
                <p class="section-status" [attr.data-testid]="'dqf-review-status-' + (info.heading | lowercase)">{{ getStatusText(info) }}</p>
                @if (getReuploadMessage(info); as reuploadMessage) {
                  <p class="reupload-hint" [attr.data-testid]="'dqf-review-reupload-' + (info.heading | lowercase)">{{ reuploadMessage }}</p>
                }
              </div>
              @if (getStatusIcon(info); as statusIcon) {
                <div class="status-indicator">
                  <mat-icon class="status-icon">{{ statusIcon }}</mat-icon>
                </div>
              }
            </div>

            @if (info.expanded) {
              <div
                class="section-content"
                [class.compact]="isOptionalDocumentNotUploaded(info) || isCarrierUploadPendingSection(info)"
                [class.has-pdf-preview]="info.value >= 10 && !isCarrierUploadPendingSection(info)"
              >
                @if (info.value === 1) {
                  <app-dqf-driver-personal-information
                    [driverVersionDetails]="driverVersionDetails">
                  </app-dqf-driver-personal-information>
                }
                @if (info.value === 2) {
                  <app-dqf-driver-contact-information
                    [driverVersionDetails]="driverVersionDetails">
                  </app-dqf-driver-contact-information>
                }
                @if (info.value === 3) {
                  <app-dqf-driver-emergency-contact
                    [driverVersionDetails]="driverVersionDetails">
                  </app-dqf-driver-emergency-contact>
                }
                @if (info.value === 4) {
                  <app-dqf-driver-license-information
                    [version]="profileInfoVersions[info.heading]">
                  </app-dqf-driver-license-information>
                }
                @if (info.value === 5) {
                  <app-dqf-driver-residence-history
                    [version]="profileInfoVersions[info.heading]">
                  </app-dqf-driver-residence-history>
                }
                @if (info.value === 6) {
                  <app-dqf-driver-driving-experience
                    [version]="profileInfoVersions[info.heading]">
                  </app-dqf-driver-driving-experience>
                }
                @if (info.value === 7) {
                  <app-dqf-driver-employment-history
                    [version]="profileInfoVersions[info.heading]">
                  </app-dqf-driver-employment-history>
                }
                @if (info.value === 8) {
                  <app-dqf-driver-accident-records [version]="profileInfoVersions[info.heading]">
                  </app-dqf-driver-accident-records>
                }
                @if (info.value === 9) {
                  <app-dqf-driver-traffic-convictions
                    [version]="profileInfoVersions[info.heading]">
                  </app-dqf-driver-traffic-convictions>
                }
                @if (info.value === 10) {
                  @if (abstractDocumentId) {
                    <app-view-uploaded-document [dqfDocumentId]="abstractDocumentId"></app-view-uploaded-document>
                  } @else if (isCarrierUploadPendingSection(info)) {
                    <div class="carrier-upload-pending-message" [attr.data-testid]="'carrier-upload-pending-' + (info.heading | lowercase)">
                      You will be able to view the document once the Carrier uploads.
                    </div>
                  }
                }
                @if (info.value === 11 || info.value === 12) {
                  @if (getUploadedDocumentId(info); as uploadedDocumentId) {
                    <app-view-uploaded-document [dqfDocumentId]="uploadedDocumentId"></app-view-uploaded-document>
                  } @else if (isCarrierUploadPendingSection(info)) {
                    <div class="carrier-upload-pending-message" [attr.data-testid]="'carrier-upload-pending-' + (info.heading | lowercase)">
                      You will be able to view the document once the Carrier uploads.
                    </div>
                  } @else {
                    <div class="document-not-uploaded-panel">
                      <div class="document-not-uploaded" data-testid="document-not-uploaded">Document is not uploaded</div>
                      <button
                        mat-raised-button
                        color="primary"
                        type="button"
                        class="upload-document-button"
                        data-test="upload-optional-document-btn"
                        [attr.data-testid]="'dqf-review-upload-' + (info.heading | lowercase)"
                        (click)="onUploadDocumentClick($event, info)"
                      >
                        Upload
                      </button>
                    </div>
                  }
                }
                @if (info.value === 13) {
                  @if (ontarioCvorAbstractId) {
                    <app-view-uploaded-document [dqfDocumentId]="ontarioCvorAbstractId"></app-view-uploaded-document>
                  } @else if (isCarrierUploadPendingSection(info)) {
                    <div class="carrier-upload-pending-message" [attr.data-testid]="'carrier-upload-pending-' + (info.heading | lowercase)">
                      You will be able to view the document once the Carrier uploads.
                    </div>
                  }
                }
                @if (info.value === 14) {
                  <app-view-uploaded-document [dqfDocumentId]="declationFormId"></app-view-uploaded-document>
                }
                @if (info.value === 15) {
                  <app-view-uploaded-document [dqfDocumentId]="employmentHistoryCheckId"></app-view-uploaded-document>
                }
              </div>
            }
          }
        </div>
      </div>
    </div>
  }
</div>
